{
  "dismiss": "התעלם"
}
